export const DONATION_CERTIFICATE_COUNTRY_OPTIONS = [
  "South Africa",
  "Other",
];

export function get_empty_certificate_form() {
  return ({
    donor_type: "natural_person",
    registration_type: "south_african_id",
    registration_number: "",
    country_of_issue: "South Africa",
    sars_tax_reference_number: "",
  });
}

export function get_certificate_registration_type_options(donor_type) {
  if (donor_type === "natural_person") {
    return [
      { value: "south_african_id", label: "South African ID" },
      { value: "foreign_passport", label: "Foreign Passport" },
    ];
  }

  if (donor_type === "company") {
    return [
      { value: "company_registration_number", label: "Company Registration Number" },
    ];
  }

  return [
    { value: "trust_registration_number", label: "Trust Registration Number" },
  ];
}

export function normalize_certificate_registration_number(value, registration_type = "") {
  const normalized_value = String(value || "");

  if (registration_type === "foreign_passport") {
    return normalized_value
      .replace(/[^A-Za-z0-9]/g, "")
      .slice(0, 20);
  }

  return normalized_value
    .replace(/\D/g, "")
    .slice(0, 20);
}


function get_sa_id_digits_error(normalized_id) {
  if (!/^\d{13}$/.test(normalized_id)) {
    return "South African ID number must be exactly 13 digits.";
  }
  return "";
}
function get_sa_id_birth_date_error(normalized_id) {
  const year = Number.parseInt(normalized_id.slice(0, 2), 10);
  const month = Number.parseInt(normalized_id.slice(2, 4), 10);
  const day = Number.parseInt(normalized_id.slice(4, 6), 10);
  const current_year_short = new Date().getFullYear() % 100;
  const full_year = year <= current_year_short ? 2000 + year : 1900 + year;
  const date = new Date(full_year, month - 1, day);
  if (
    date.getFullYear() !== full_year
    || date.getMonth() !== month - 1
    || date.getDate() !== day
  ) {
    return "South African ID number contains an invalid birth date.";
  }
  return "";
}
function get_sa_id_citizenship_error(normalized_id) {
  const citizenship = Number.parseInt(normalized_id.slice(10, 11), 10);
  if (![0, 1, 2].includes(citizenship)) {
    return "South African ID number contains an invalid citizenship digit.";
  }
  return "";
}
function has_valid_sa_id_checksum(normalized_id) {
  let sum = 0;
  for (let index = 0; index < normalized_id.length; index += 1) {
    let digit = Number.parseInt(normalized_id.charAt(index), 10);
    if (index % 2 !== 0) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }
    sum += digit;
  }
  return sum % 10 === 0;
}
function get_sa_id_number_error(id_number) {
  const normalized_id = String(id_number || "").trim();
  return (
    get_sa_id_digits_error(normalized_id)
    || get_sa_id_birth_date_error(normalized_id)
    || get_sa_id_citizenship_error(normalized_id)
    || (!has_valid_sa_id_checksum(normalized_id) ? "South African ID number checksum is invalid." : "")
  );
}
export function validate_sa_id_number(id_number) {
  return !get_sa_id_number_error(id_number);
}
export function get_certificate_registration_number_error(registration_type, value) {
  const normalized_value = String(value || "").trim();
  if (!normalized_value) {
    return "ID / registration number is required.";
  }
  if (registration_type === "south_african_id") {
    return get_sa_id_number_error(normalized_value);
  }
  if (registration_type === "foreign_passport" && !/^[A-Za-z0-9]{6,20}$/.test(normalized_value)) {
    return "Passport number must be 6 to 20 letters or numbers.";
  }
  return "";
}
export function normalize_certificate_sars_tax_reference_number(value) {
  return String(value || "")
    .replace(/\D/g, "")
    .slice(0, 10);
}

export function get_certificate_sars_tax_reference_number_error(value) {
  const normalized_value = String(value || "").trim();

  if (!normalized_value) {
    return "SARS tax reference number is required.";
  }

  if (!/^\d{10}$/.test(normalized_value)) {
    return "SARS tax reference number must be exactly 10 digits.";
  }

  return "";
}


export function get_empty_certificate_form_errors() {
  return ({
    donor_type: "",
    registration_type: "",
    registration_number: "",
    country_of_issue: "",
    sars_tax_reference_number: "",
  });
}

export function get_certificate_form_errors(form = {}) {
  return ({
    donor_type: String(form.donor_type || "").trim() ? "" : "Donor type is required.",
    registration_type: String(form.registration_type || "").trim() ? "" : "ID / registration type is required.",
    registration_number: get_certificate_registration_number_error(form.registration_type, form.registration_number),
    country_of_issue: String(form.country_of_issue || "").trim() ? "" : "Country of issue is required.",
    sars_tax_reference_number: get_certificate_sars_tax_reference_number_error(form.sars_tax_reference_number),
  });
}





